export default __webpack_public_path__ + "static/media/phoneShowcase.c58e433b.png";